import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceNo'
})
export class ReplaceNoPipe implements PipeTransform {
  transform(value: string): string {
    if(value == 'No'){
      return '-';
    }

    if(value == 'Si'){
      return '-';
    }
    return value;
  }
}